import type { Campaign } from '@/payload-types'

export const CAMPAIGN_CAROUSEL_LIMIT = 20

/**
 * Campaign is still active if its end calendar day (UTC) is today or later.
 */
export function isCampaignActive(campaign: Pick<Campaign, 'endDate'>): boolean {
  if (!campaign.endDate) return false
  const end = new Date(campaign.endDate)
  if (Number.isNaN(end.getTime())) return false
  const endYmd =
    end.getUTCFullYear() * 10000 + (end.getUTCMonth() + 1) * 100 + end.getUTCDate()
  const now = new Date()
  const nowYmd =
    now.getUTCFullYear() * 10000 + (now.getUTCMonth() + 1) * 100 + now.getUTCDate()
  return endYmd >= nowYmd
}

export function isFeaturedActiveCampaign(campaign: Campaign): boolean {
  return campaign.featured === true && isCampaignActive(campaign)
}

export function isFeaturedPastCampaign(campaign: Campaign): boolean {
  return campaign.featured === true && !isCampaignActive(campaign)
}
